import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { WorkflowReportVolumesByCountryResponse } from "@idw-types/data/reports";

export const getWorkflowReportVolumesRequestByCountry = async (
    queryParameters: Array<QueryParameter>
): Promise<{ data: WorkflowReportVolumesByCountryResponse, error: any }> => {
    const route = apiRoutes.reports.workflowReport.volumesByCountry;

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};